export default {"src":"/_next/static/media/medal-badge.a8190981.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};